module.exports = __webpack_public_path__ + "media/27-01b.e54f03dc.mp4";